import update from "immutability-helper";
import {
  GET_POLICIES,
  GET_PUBLISHERS,
  GET_ACCEPTANCES,
  SET_STATUS,
} from "../constants/actionTypes";

const policies = (state = {}, action) => {
  switch (action.type) {
    case GET_PUBLISHERS:
      return update(state, {
        publishers: { $set: action.payload },
      });
    case GET_POLICIES:
      return update(state, {
        policies: { $set: action.policies },
        archivedPolicies: { $set: action.archivedPolicies },
      });
    case GET_ACCEPTANCES:
      return update(state, {
        acceptances: { $set: action.payload },
      });
    case SET_STATUS:
      return update(state, {
        status: { $set: action.payload },
      });
    default:
      return state;
  }
};

export default policies;
